import axios from "axios";
import Cookies from "core-js/internals/queue";
import resolve from "resolve";

let baseUrl=''
switch (process.env.NODE_ENV){
    case 'development':
        baseUrl='https://yxtest.readboy.com/admin/api'
        break
    case 'production':
        baseUrl='https://yx.readboy.com/admin/api'
        break
    case 'release':
        baseUrl='https://yxtest.readboy.com/admin/api'
}

const instance = axios.create({
    baseURL:baseUrl,
    timeout:10000
})

instance.interceptors.request.use((config) => {
    let token=localStorage.getItem('token')
    if(token){
        config.headers['authorization']='Bearer '+token
    }
    config.headers['Content-Type'] = 'application/json'

    return config
},error => {

    return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        const res = response.data
        return res

    },
    error => {
        let message = ''
        if (/timeout\sof\s\d+ms\sexceeded/.test(error.message)) {
            message = '网络出了点问题，请稍后重试！'
        }
        if (error.message === 'Network Error') message = '网络出了点问题，请稍后重试！'
        if (error.response) {
            // http状态码判断
            switch (error.response.status) {
                // http status handler
                case 401:
                    message = '账号或密码错误！'
                    break
                case 404:
                    message = '请求的资源不存在！'
                    break
                case 500:
                    message = '内部错误，请稍后重试！'
                    break
                case 503:
                    message = '服务器正在维护，请稍等！'
                    break
            }
        }
        const reason = { ...error.response, message: message || error.message }
        return Promise.reject(reason)
    }
)

export function allCategories() {
    return instance({
        url: "/material_categories",
        method: "get",
    })
}
export function getPage(page){
    return instance({
        url:'/materials',
        method:'get',
        params:{
            page
        }
    })
}
export function selectCategory(top_category_id,second_category_id, page){
    return instance({
        url:'/materials',
        method:'get',
        params:{
            top_category_id,
            second_category_id,
            page
        }
    })
}
export function search(name,page){
    return instance({
        url:'/materials/searches',
        method:'get',
        params:{
            name,
            page
        }
    })
}
export function login(username,password){
    return instance({
        url:'/login',
        method:'post',
        params:{
            username,
            password
        }
    })
}
export default instance
